import { postApi } from "@/utils/http";
import { baseUrl } from "./settings";
import router from "@/router";
import store from "@/store";
import io from "socket.io-client";
import { packageNotice } from "@/utils/packageNotice";
import { computerNotice } from "@/utils/computerNotice";
import { handlePowershellEvent } from "@/utils/powershell";
import {
  getPackageNameVersionAndHash,
  getChocoPackageFromMdcPackage,
} from "./mdc";

import { scrollToEnd } from "@/utils/document";

import { getPackageStats } from "@/utils/groupPackage";

export let instance = null;

export async function connect(domain) {
  try {
    if (shouldDisconnect()) {
      if (store.state.socket.connected && instance) {
        disconnect();
      }
    }

    if (shouldConnect(domain)) {
      store.commit("socket/setConnecting", true);

      if (!domain) {
        await store.dispatch("domain/fetch");
        domain = store.state.domain.domains.find(
          (x) => x.uid === router.currentRoute.params.domainUID
        );
      }

      store.commit("socket/setDomain", domain);

      const authRes = await postApi("get/userSocketToken", {});
      const authData = authRes[0];
      const { sessionId, token } = authData;

      instance = io(baseUrl, {
        ignoreServerCertificateValidation: false,
        query: `userUID=${store.state.auth.user.userUID}&sessionId=${sessionId}&token=${token}&domainKey=${domain.key}`,
        reconnection: false,
        forceNew: false,
      });

      // store.commit(
      //   "socket/setInstance",
      //   Object.freeze(
      //     io(baseUrl, {
      //       ignoreServerCertificateValidation: false,
      //       query: `userUID=${store.state.auth.user.userUID}&sessionId=${sessionId}&token=${token}&domainKey=${domain.key}`,
      //       reconnection: false,
      //       forceNew: false,
      //     })
      //   )
      // );

      setEvents();
      store.commit("socket/setConnecting", false);
    }
  } catch (err) {
    store.commit("socket/setConnecting", false);
    console.error(err);
    await wait(5000);
    connect();
  }
}

export function disconnect() {
  if (store.state.socket.connected && instance) {
    store.commit("socket/setReconnect", false);
    instance.disconnect();
  }
}

function shouldConnect(domain) {
  return (
    domain ||
    (!store.state.socket.connected &&
      !store.state.socket.connecting &&
      router.currentRoute.params.domainUID)
  );
}

function shouldDisconnect() {
  return (
    (store.state.socket.domain &&
      store.state.socket.domain.uid !== router.currentRoute.params.domainUID) ||
    !router.currentRoute.params.domainUID
  );
}

function wait(time) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
}

function setEvents() {
  setEvent("psStream", (data) => {
    //console.log("psStream", data);

    if (store.state.powershell.computerUID === data.computerUID) {
      handlePowershellEvent(data);
    }
  });

  setEvent("packageExecLog", (data) => {
    if (data && data.computerUID) {
      if (router.currentRoute.params.computerUID == data.computerUID) {
        const existing = store.getters["computerPackage/mergedPackage"]({
          package: { name: data.id },
          version: { version: data.version },
          source: { uid: data.sourceUID },
        });

        if (existing) {
          if (existing.command.execLog)
            existing.command.execLog += "\n" + data.execLog;
          if (!existing.command.execLog)
            existing.command.execLog = data.execLog;

          store.commit("computerPackage/mergeMergedPackage", existing);

          setTimeout(() => {
            scrollToEnd("modal-body");
          }, 50);
        }
      }
    }
  });

  setEvent("systemInfoChange", (data) => {
    //console.log("systemInfoChange", data);
    if (
      data &&
      router.currentRoute.params.domainUID &&
      router.currentRoute.params.domainUID === store.state.computer.domainUID
    ) {
      store.dispatch("computer/mergeComputer", {
        c: data,
        obj: data,
        domainUID: store.state.computer.domainUID,
      });
    }
  });

  setEvent("computerChange", (data) => {
    //console.log("computerChange", data);

    if (
      data &&
      router.currentRoute.params.domainUID &&
      router.currentRoute.params.domainUID === store.state.computer.domainUID
    ) {
      if (data && data.uid) {
        computerNotice(data);
      }

      store.dispatch("computer/mergeComputer", {
        c: data,
        obj: data,
        domainUID: store.state.computer.domainUID,
      });
    }
  });

  setEvent("packageChange", async (data) => {
    //console.log("packageChange", data);
    if (
      router.currentRoute.params.computerUID &&
      data.computerUIDs.some(
        (x) => x === router.currentRoute.params.computerUID
      )
    ) {
      handleComputerPackageChange(data);
    } else if (router.currentRoute.params.groupUID) {
      handleGroupPackageChange(data);
    }
  });

  setEvent("connect", () => {
    store.commit("socket/setConnected", true);
    console.log("connected");
  });

  setEvent("disconnect", async () => {
    console.log("disconnected");

    store.commit("socket/setConnected", false);
    if (store.state.socket.reconnect) {
      await wait(3000);
      console.log("reconnecting");
      connect();
    }
  });
}

export function sendPowershellCommand(computerUID, command) {
  if (store.state.socket.connected) {
    instance.emit("psCommand", {
      computerUID: computerUID,
      command,
    });
    return true;
  }
  return false;
}

export function send(event, data) {
  if (!store.state.socket.connected) return false;

  instance.emit(event, data);

  return true;
}

export function requestLog(computerUIDs) {
  if (store.state.socket.connected) {
    instance.emit("command", {
      computerUIDs: computerUIDs,
      name: "request",
      eventString: "logRequest",
    });
    return true;
  }
  return false;
}

export function requestGroupPackagesUpdate(groupUID, computerUIDs) {
  if (store.state.socket.connected) {
    instance.emit("command", {
      computerUIDs: computerUIDs,
      groupUID: groupUID,
      name: "send",
      queryName: "computerGroupPackages",
      eventString: "packageChange",
    });
    return true;
  }
  return false;
}

export function disconnectComputers(computerUIDs) {
  if (store.state.socket.connected) {
    instance.emit("command", {
      computerUIDs: computerUIDs,
      name: "disconnect",
    });

    return true;
  } else return false;
}

export function cancelGroupPackageSchedule(groupUID, computerUIDs) {
  if (store.state.socket.connected) {
    instance.emit("command", {
      computerUIDs: computerUIDs,
      groupUID: groupUID,
      name: "send",
      queryName: "computerGroupPackages",
      eventString: "cancelPackageSchedule",
    });

    return true;
  } else return false;
}

export function cancelPackageSchedule(packages, computerUIDs) {
  if (store.state.socket.connected) {
    instance.emit("cancelPackageSchedule", {
      computerUIDs,
      packages,
    });

    return true;
  } else return false;
}

async function getChocoPackage(existingMergedPackage, mdcPackage) {
  const p = { ...mdcPackage };

  if (
    !existingMergedPackage ||
    !existingMergedPackage.chocoPackage ||
    !existingMergedPackage.chocoPackage.Id
  ) {
    const chocoPackage = await getChocoPackageFromMdcPackage(
      p,
      router.currentRoute.params.domainUID
    );

    if (chocoPackage) p.chocoPackage = chocoPackage.chocoPackage;
    else console.error("choco package was not found");
  } else p.chocoPackage = existingMergedPackage.chocoPackage;

  return p;
}

function setEvent(event, fn) {
  instance.on(event, fn);
  //store.commit("socket/setEvent", { event: event, fn: fn });
}

async function handleComputerPackageChange(data) {
  for (const p of data.packages) {
    store.commit("computerPackage/mergeMdcPackage", p);

    store.dispatch("infobar/checkAndSetPackage", p);

    const { name, uid } = getPackageNameVersionAndHash(p);

    const existingPackages =
      store.state.computerPackage.mergedPackages[name + uid];

    if (
      !existingPackages ||
      existingPackages.filter((x) => x.visible || x.selected).length === 0
    ) {
      const mergedPackage = await getChocoPackage(null, p);
      mergedPackage.selected = true;
      store.commit("computerPackage/mergeMergedPackage", mergedPackage);
      packageNotice(mergedPackage);
    } else {
      const existing = store.getters["computerPackage/mergedPackage"](p);
      if (existing) p.chocoPackage = existing.chocoPackage;
      if (
        existing &&
        existing.command &&
        existing.command.execLog &&
        (p.command.status == "done" || p.command.status == "failed")
      )
        p.command.execLog = existing.command.execLog;

      store.commit("computerPackage/mergeMergedPackage", p);
      packageNotice(p);
    }
  }
}

async function handleGroupPackageChange(data) {
  for (const p of data.packages) {
    const { name, version, uid } = getPackageNameVersionAndHash(p);
    const location = name + version + uid;

    await store.dispatch("group/fetch", {
      domainUID: router.currentRoute.params.domainUID,
    });

    const group = store.getters["group/single"](
      router.currentRoute.params.groupUID
    );

    store.commit("groupPackage/mergeComputerPackage", p);

    const stats = getPackageStats(
      store.state.groupPackage.computerPackages[location],
      group.computers,
      p
    );
    store.commit("groupPackage/editMergedPackage", {
      p: p,
      obj: { stats: stats },
    });
  }
}

export function sendPackages(packages, computerUIDs, groupUID) {
  if (store.state.socket.connected) {
    instance.emit("packageChange", {
      groupUID,
      computerUIDs,
      packages,
    });

    return true;
  } else return false;
}
